import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { ICellRendererParams, ColDef } from "ag-grid-community";
import clsx from "clsx";
import PreviewIcon from "@material-ui/icons/VisibilityOutlined";
import IconButton from "@material-ui/core/IconButton";
import { UIStyledTooltip } from "../../ui/UIComponents";
import UIModal from "../../ui/UIModal";
import { FormattedViewContext } from "../colDef";
import { getFormattedDataForView } from "../data-formatters";
import { UIDisplayFields } from "../UIFormattedView";

export type QuickViewParams = {
	icon?;
	getId?: (data: any) => string;
	getTitle?: (data: any) => string;
	getPreviewTitle?: (data: any) => string;
	getUrl?: (data: any) => string;
	noHash?: boolean;
	omitSettings?: boolean;
	btnRowClassName?: string;
	hideBtn?: boolean;
	onClose?: () => any;
};

type QuickViewRendererParams = ICellRendererParams &
	QuickViewParams & {
		colDefs: ColDef[];
		primaryBtn?: React.ReactNode;
		closeBtnTxt?: string;
	};

type QuickViewRendererCProps = QuickViewRendererParams;

const QuickViewRendererC: React.FC<QuickViewRendererCProps> = (props: QuickViewRendererCProps) => {
	const [open, setOpen] = useState<boolean>(props.hideBtn);
	const [refresh, setRefresh] = useState<number>(0);
	const [data, setData] = useState<any>(props.data);
	const [loading, setLoading] = useState<boolean>(false);

	// useEffect(() => {
	// 	setLoading(false);
	// }, [props.userSettings[QUICKVIEW_SELECTED_SETTING_KEY]]);

	if (!data) return <span></span>;

	const id: string = props.getId ? props.getId(data) : undefined;
	const previewTitle: string = props.getPreviewTitle
		? props.getPreviewTitle(data)
		: `View${id ? ` ${props.noHash ? "" : "#"}${id}` : ""}`;
	const pageTitle: string = props.getTitle ? props.getTitle(data) : "View";
	const url: string = props.getUrl ? props.getUrl(data) : undefined;
	const modalTitle: string | React.ReactNode = url ? <Link to={url}>{pageTitle}</Link> : <>{pageTitle}</>;
	let colDefs: ColDef[] = props.colDefs;

	return (
		<>
			{/* <UIStyledTooltip title={previewTitle}> */}
			{!props.hideBtn && (
				<button
					className="btn btn-link p-0 w-100 font-weight-bold"
					style={{ border: "none 0px" }}
					onClick={(e) => {
						e.preventDefault();
						setOpen(true);
					}}
				>
					View
				</button>
			)}
			{/* <IconButton
					// edge="start"
					aria-label={previewTitle}
					// size="small"
					className="action-btn-icon xs"
					onClick={(e) => {
						e.preventDefault();
						setOpen(true);
					}}
				>
					{props.icon || <PreviewIcon fontSize="small" />}
				</IconButton> */}
			{/* </UIStyledTooltip> */}
			{open && (
				<UIModal
					title={modalTitle}
					pageTitle={pageTitle}
					open={open}
					onClose={() => {
						setOpen(false);
						if (props.onClose) {
							props.onClose();
						}
					}}
					showCloseIcon={true}
					noPadding={true}
					// className="wide-modal"
				>
					<div
						className={clsx(
							"container-fluid corre-detail-page corre-quick-view",
							loading && "progress-bg loading"
						)}
						style={{ marginTop: "0.6rem" }}
						key={refresh}
					>
						<FormattedViewContext.Provider
							value={{
								viewData: getFormattedDataForView<any>(
									colDefs,
									data,
									(data) => {
										setData(data);
										setRefresh(refresh + 1);
									},
									"list",
									props
								),
							}}
						>
							<UIDisplayFields cols={colDefs as any} omitFieldIfEmpty={true} />
						</FormattedViewContext.Provider>
						<div className={clsx("form-row d-flex justify-content-end", props.btnRowClassName)}>
							{props.primaryBtn}
							<button
								className="btn btn-link mt-1 mr-1"
								type="button"
								onClick={() => {
									setOpen(false);
									if (props.onClose) {
										props.onClose();
									}
								}}
							>
								{props.closeBtnTxt || "Close"}
							</button>
						</div>
					</div>
				</UIModal>
			)}
		</>
	);
};

export const QuickViewRenderer = QuickViewRendererC;
